import { configure, set } from "vue-gtag";
import { TENANT_SLUG } from "@/config/index.js";
import { isPublicNoTrackingRoute } from "./publicNoTrackingRoute";

export function setupAnalytics() {
  if (isPublicNoTrackingRoute()) {
    console.info("GTAG is disabled on this route");

    return;
  }

  if (import.meta.env.VITE_GTAG_ID) {
    configure({ tagId: import.meta.env.VITE_GTAG_ID });

    set("user_properties", { tenant: TENANT_SLUG });
  } else {
    console.info("GTAG is disabled");
  }
}
